import { TransitionEvents } from '@hotstar/use-is-page-transitioning';
import { parseCookieString } from '@hotstar/utils';
import type { CustomErrorLrProps } from '@hotstar/web-ui-components-lib';
import type { EpdErrorPageLrExtraProps } from '@hotstar/web-ui-components-lib/legacy/components/Template/EpdErrorLr/src';

export const EPD_ERROR_PAGE_STATIC_PROPS: CustomErrorLrProps = {
  title: 'Connection Error',
  subtitle: '',
  description:
    "Looks like you are connecting through a VPN, proxy or 'unblocker' service. Please turn off any of these services and try again.",
  primaryButton: {
    label: 'Retry',
    icon: 'icon-retry'
  }
};

export const EPD_ERROR_PAGE_UN_SERIALIZABLE_PROPS: EpdErrorPageLrExtraProps = {
  onPrimaryButtonEnterPress: () => {
    import('@hotstar/use-is-page-transitioning').then((useTransitioning) => {
      useTransitioning.triggerTransitionEvent(TransitionEvents.START);
    });
    window?.location?.reload();
  },
  getGrnValue: () => {
    const cookies = document.cookie;
    return cookies && parseCookieString(cookies, 'x-akamai-grn');
  }
};
